export default __webpack_public_path__ + "static/3_2-5bb8b5899579b3dd0e45e58fb50b1e5c.png";